export default "__VITE_ASSET__dc2f6eea__"